import instance from '../API/api';

export const adminNotificationController = {
  async getList() {
    const { data } = await instance.get('notifications/admin/list');
    return data?.data?.map((item: any) => {
      const notification = item.notification ?? {};

      const user =
        notification.user && notification.user.id
          ? {
              first_name: notification.user.first_name ?? '',
              second_name: notification.user.second_name ?? '',
              id: notification.user.id ?? '',
              additionalData: notification.user.additionalData ?? {},
            }
          : null;

      const company =
        notification.company && notification.company.id
          ? {
              name: notification.company.name ?? '',
              id: notification.company.id ?? '',
            }
          : null;

      return {
        id: notification.id ?? '',
        title: notification.title ?? '',
        description: notification.description ?? '',
        createdAt: notification.createdAt ?? '',
        read: item.is_read ?? false,
        user,
        company,
      };
    });
  },

  async markAllAsRead() {
    await instance.put('notifications/admin/read-all');
  },

  async getUnreadCount() {
    const { data } = await instance.get('/notifications/admin/unread-count');
    return data.count;
  },

  async markAsRead(id: string) {
    return await instance.get(`/notifications/admin/find/${id}`);
  },
};
